import React, { useEffect, useRef, useState } from "react";
import s from "./Presentation.module.css";

const PresentationElement = (props) => {
  const cardRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const hasImage = Boolean(props.img);

  useEffect(() => {
    const node = cardRef.current;
    if (!node) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.55, rootMargin: "0px 0px -8% 0px" }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  const cardBackground = hasImage
    ? `linear-gradient(180deg, rgba(0, 0, 0, 0.52), rgba(0, 0, 0, 0.84)), url('${props.img}')`
    : "linear-gradient(180deg, rgba(116, 17, 17, 0.82), rgba(69, 8, 8, 0.88))";

  return (
    <article
      ref={cardRef}
      className={`${s.element} ${isVisible ? s.inView : ""}`}
      data-snap-section="true"
      style={{ backgroundImage: cardBackground }}
    >
      <div className={s.description}>
        <p className={s.name}>{props.name}</p>
        <p className={s.cardText}>{props.text}</p>
      </div>
    </article>
  );
};

export default PresentationElement;
